import { SVGProps } from 'react';
const PipelineIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        viewBox="0 0 16 16"
    >
        <path
            fillRule="evenodd"
            d="M5.762 2h4.51V4.813a1 1 0 0 1 .602.918v.857a1 1 0 0 1-.603.918v.684H10.956a1 1 0 0 1 .918-.602h.857a1 1 0 0 1 .918.602h1.384v4.51H13.65a1 1 0 0 1-.918.602h-.857a1 1 0 0 1-.918-.602H5.077a1 1 0 0 1-.917.602h-.858a1 1 0 0 1-.917-.602H1V8.19H2.385a1 1 0 0 1 .917-.602h.858a1 1 0 0 1 .917.602h.685v-.684a1 1 0 0 1-.602-.918v-.857a1 1 0 0 1 .602-.918V2Zm-3.46 6.89H1.7V12h.602V8.89Zm8.572 0V12H5.16V8.89h1.302V7.588h3.11V8.89h1.302ZM13.73 12h.602V8.89h-.602V12Zm-4.16-9.3v2.031h-3.11V2.7h3.11Zm.303 2.731H6.16a.3.3 0 0 0-.3.3v.857a.3.3 0 0 0 .3.3h3.714a.3.3 0 0 0 .3-.3v-.857a.3.3 0 0 0-.3-.3ZM3.002 8.588v3.714a.3.3 0 0 0 .3.3h.858a.3.3 0 0 0 .3-.3V8.588a.3.3 0 0 0-.3-.3h-.858a.3.3 0 0 0-.3.3Zm8.572 3.714V8.588a.3.3 0 0 1 .3-.3h.857a.3.3 0 0 1 .3.3v3.714a.3.3 0 0 1-.3.3h-.857a.3.3 0 0 1-.3-.3Z"
            clipRule="evenodd"
        />
    </svg>
);
export default PipelineIcon;
